import { render, staticRenderFns } from "./DeleteStorageTracking.vue?vue&type=template&id=f24acff8&"
import script from "./DeleteStorageTracking.vue?vue&type=script&lang=js&"
export * from "./DeleteStorageTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports